module.exports = __webpack_public_path__ + "static/media/feature-recommedation.64d41d3b.png";